/**
 * <dt-related-products>: loads Shopify's product recommendations for the current product
 * (sections/dt-related-products.liquid) and swaps them in. Recommendations are only available
 * through a separate request, so the section renders an empty shell first. It stays hidden when
 * the store returns no recommendations or the request fails.
 */
class DtRelatedProducts extends HTMLElement {
  /** @type {AbortController | undefined} */
  #controller;

  connectedCallback() {
    if (this.dataset.loaded === 'true' || !this.dataset.url) return;
    this.#controller?.abort();
    this.#controller = new AbortController();
    this.#load(this.#controller.signal);
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  /** @param {AbortSignal} signal */
  async #load(signal) {
    try {
      const response = await fetch(this.dataset.url || '', { signal });
      if (!response.ok) return;
      const html = await response.text();
      if (signal.aborted) return;

      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('dt-related-products');
      if (!fresh || !fresh.querySelector('dt-product-card, .dt-card')) return;

      this.replaceChildren(...fresh.children);
      this.dataset.loaded = 'true';
      this.hidden = false;
    } catch {
      // Request cancelled or failed: the section simply stays hidden.
    }
  }
}

if (!customElements.get('dt-related-products')) customElements.define('dt-related-products', DtRelatedProducts);
